const FS_HAS_BLOOMREACH = "fs_has_bloomreach";
export default class Bloomreach {
    static setHasBloomreach(value) {
        if (value) {
            localStorage.setItem(FS_HAS_BLOOMREACH, "true");
        }
        else {
            localStorage.removeItem(FS_HAS_BLOOMREACH);
        }
    }
    static getHasBloomreach() {
        const hasBloomreach = localStorage.getItem(FS_HAS_BLOOMREACH);
        return hasBloomreach === "true";
    }
}
//# sourceMappingURL=bloomreach.js.map